export enum enumCreTitle {
  NA= 1,
  Mr,
  Mrs,
  Miss,
  Ms,
  Prof,
  Dr,
  Other,
  Ds,
  Unkown
}

export namespace enumCreTitle {
  export function values() {
    return Object.keys(enumCreTitle).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
